import * as t from "./tweakpane.min.js";


export default class TweakPane
{
  constructor()
  {


    this.pane = new t.Pane({
      title: 'Tweak Panel',
      expanded: false
    });

    this.pane.hidden = true;
  }

  toggle()
  {
    this.pane.hidden = !this.pane.hidden;
  }
}
